import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ExpandedTable } from "@ryde/controls";

import { GenericUploadRowConflictsContext } from "../../contexts";
import { RowConflictsExpanded } from "./row-conflicts-expanded";

export const ValidationFailedTable: FC = () => {
  const { conflicts } = useContext(GenericUploadRowConflictsContext);

  const { t } = useTranslation();

  return (
    <RowConflictsExpanded>
      <ExpandedTable dataE2E="row-conflicts-validation-failed-table">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("general.index")}</TableCell>
              <TableCell>{t("general.message")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {conflicts?.map((conflict, idx) => (
              <TableRow key={`${conflict.index}_${idx}`}>
                <TableCell>{conflict.index}</TableCell>
                <TableCell>{conflict.messages?.join(", ") || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ExpandedTable>
    </RowConflictsExpanded>
  );
};
